import React from "react";

const MainHeader = ({ children }) => {
  return (
    <div className="flex items-center justify-between pb-4">
      {children}
    </div>
  );
};

export default MainHeader;
